import React, { useEffect, useState } from "react";
import BackBG from "../../../assets/images/icons/box.svg";
import { Link } from "react-router-dom";
import PerformanceService from "../../../services/performance.service";
import Loader from "../../../assets/images/icons/loader.gif";

const Milestones = () => {
  const [gameUnlock, setGameUnlock] = useState({});
  const [footballVisionair, setFootballVisionair] = useState({});
  console.log("🚀 ~ Milestones ~ footballVisionair:", footballVisionair);
  const [footballGeek, setFootballGeek] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const milestone = localStorage.getItem("favoriteMilestone");
  const option = ["QUICKFEET", "Visionair", "Geek", "QUICKFEET Challege"];
  const getMilestones = async () => {
    setIsLoading(true);
    try {
      const response = await PerformanceService?.getMilestones();
      if (response) {
        setGameUnlock(response?.data?.gameUnlock);
        setFootballVisionair(response?.data?.footballVisionair);
        setFootballGeek(response?.data?.footballGeek);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMilestones();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="h-[calc(100vh-270px)] flex justify-center items-center">
          <img src={Loader} alt="Loader" className="w-16 h-16" />
        </div>
      ) : (
        <div className="mt-10">
          <div className="grid gap-10 text-white">
            <div className="grid gap-2">
              <div className="relative w-fit h-14">
                <img
                  src={BackBG}
                  alt="Button Background"
                  className="w-full h-full"
                />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-sm text-primary whitespace-nowrap">
                  You're Quick
                </span>
              </div>
              <div
                className={`grid items-start gap-3 p-4 rounded-lg border border-white/30 w-full ${
                  milestone == "QUICKFEET" ? "bg-[#87D186] text-black" : ""
                } duration-200`}
              >
                <h3 className="text-3xl font-semibold">
                  {gameUnlock?.message
                    ? gameUnlock?.message
                    : "Your new game will be unlock after 99 games"}
                </h3>
                <p>
                  Players receive a new game after playing 5 hours. This counter
                  shows how manygames thay have to play before it’s unlocked.
                  Before playing the first game itshows the number 99. it must
                  count automatically based on the played games
                </p>
              </div>
            </div>
            <div className="grid gap-2">
              <div className="relative w-fit h-14">
                <img
                  src={BackBG}
                  alt="Button Background"
                  className="w-full h-full"
                />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-sm text-primary whitespace-nowrap">
                  Football Visionair
                </span>
              </div>
              <div
                className={`grid items-start gap-3 p-4 rounded-lg border border-white/30 w-full ${
                  milestone == "Visionair" ? "bg-[#87D186] text-black" : ""
                } duration-200`}
              >
                <h3 className="text-3xl font-semibold">
                  {footballVisionair?.message
                    ? footballVisionair?.message
                    : `Your new game will be unlocked after ${
                        footballVisionair?.gameAvg || "0%"
                      } progression for one
                specific game`}
                </h3>
                <p>
                  When having 30% progression in numbers colors or shapes. Only
                  possible if you have this 3 times minimum with different
                  scores.
                </p>
              </div>
            </div>
            <div className="grid gap-2">
              <div className="relative w-fit h-14">
                <img
                  src={BackBG}
                  alt="Button Background"
                  className="w-full h-full"
                />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-sm text-primary whitespace-nowrap">
                  Football Geek
                </span>
              </div>
              <div
                className={`grid items-start gap-3 p-4 rounded-lg border border-white/30 w-full ${
                  milestone == "Geek" ? "bg-[#87D186] text-black" : ""
                } duration-200`}
              >
                <h3 className="text-3xl font-semibold">
                  {footballGeek?.message
                    ? footballGeek?.message
                    : `Your new game will be unlocked after ${footballGeek?.gameAverage} progression in 1 education game`}
                </h3>
                <p>
                  Players receive a new game after playing make it 9,
                  calculation and Recall more then 50 times combined.
                </p>
              </div>
            </div>
            <div className="grid gap-2">
              <div className="relative w-fit h-14">
                <img
                  src={BackBG}
                  alt="Button Background"
                  className="w-full h-full"
                />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-sm text-primary whitespace-nowrap">
                  Cashback & Price
                </span>
              </div>
              <a
                href="https://quickfeet.net/challenges-leagues/"
                target="_blank"
              >
                <div
                  className={`grid items-start gap-3 p-4 rounded-lg border border-white/30 w-full hover:bg-[#87D186] hover:text-black ${
                    milestone == "QUICKFEET Challege"
                      ? "bg-[#87D186] text-black"
                      : ""
                  } duration-200`}
                >
                  <h4 className="text-xl">
                    Want to win cashback or other prices?
                  </h4>
                  <h3 className="text-3xl font-semibold">
                    Join the monthly QUICKFEET challenge
                  </h3>
                  <p>This is linked to our web page withmonthly challenges</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Milestones;
